import React, { useState } from "react";
import alyseiIcon from "../../../assets/landing-page/alysei-icon-only.png";
import avatarLogo from "../../../assets/landing-page/about/avatar-logo.jpg";

const BROWSE_ALL_VALUE = "__browse_all_categories__";

const formatTime = (timestamp) => {
  const d = new Date(timestamp);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const UserBubble = ({ message }) => {
  return (
    <div className="flex items-start gap-2 justify-end animate-fadeIn">
      <div className="flex flex-col items-end gap-1" style={{ maxWidth: "75%" }}>
        <div className="text-white px-3 py-2 rounded-xl rounded-br-sm shadow-sm text-sm leading-relaxed" style={{ backgroundColor: "#0d9488" }}>
          {message.text}
        </div>
        <span className="text-gray-400 px-1  text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
      </div>

      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 shadow overflow-hidden">
        <img src={avatarLogo} alt="User avatar" className="w-full h-full object-cover" />
      </div>
    </div>
  );
};

const CategoryButton = ({ label, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="text-left text-sm px-4 py-3 rounded-lg bg-white border disabled:opacity-50 transition-colors"
    style={{
      borderColor: "#d1d5db",
      color: "#004577",
      fontWeight: 600,
      fontSize: "13px",
      boxShadow: "none",
    }}
    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f0f6ff"; }}
    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#fff"; }}
  >
    {label}
  </button>
);

const INITIAL_SHOW_COUNT = 14;

const QuickRepliesGrid = ({ quickReplies, onQuickReply, isLoading }) => {
  const [showAll, setShowAll] = useState(false);

  const regularReplies = quickReplies.filter((r) => r.value !== BROWSE_ALL_VALUE);
  const visible = showAll ? regularReplies : regularReplies.slice(0, INITIAL_SHOW_COUNT);
  const hasMore = regularReplies.length > INITIAL_SHOW_COUNT;

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {visible.map((reply) => (
        <button
          key={reply.value}
          onClick={() => onQuickReply(reply.value)}
          disabled={isLoading}
          className="text-xs rounded-full px-3 py-1 bg-white disabled:opacity-50"
          style={{ color: '#374151', border: '1px solid #d1d5db', transition: 'border-color 0.2s, color 0.2s' }}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#2dd4bf'; e.currentTarget.style.color = '#0d9488'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.color = '#374151'; }}
        >
          {reply.label}
        </button>
      ))}
      {hasMore && (
        <button
          onClick={() => setShowAll((v) => !v)}
          className="text-xs rounded-full px-3 py-1 bg-white"
          style={{ color: '#0d9488', border: '1px solid #2dd4bf', transition: 'background-color 0.2s' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0fdfa'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
        >
          {showAll ? 'see less' : 'see more'}
        </button>
      )}
    </div>
  );
};

const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+)/g;
const URL_TEST_REGEX = /^https?:\/\//;

const renderTextWithLinks = (text) => {
  const parts = text.split(URL_SPLIT_REGEX);
  return parts.map((part, i) =>
    URL_TEST_REGEX.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#0d9488", textDecoration: "underline", wordBreak: "break-word" }}
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};

const AssistantBubble = ({ message, onQuickReply, isLoading }) => (
  <div className="flex items-start gap-3 justify-start animate-fadeIn">
    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center flex-shrink-0 overflow-hidden shadow mt-0.5">
      <img src={alyseiIcon} alt="Alysei AI" className="w-5 h-5 object-contain" />
    </div>

    <div className="flex flex-col gap-1" style={{ maxWidth: "88%" }}>
      {message.text ? (
        <div className="bg-white border border-gray-100 shadow-sm px-3 py-2 rounded-xl rounded-bl-sm text-sm text-gray-800 leading-relaxed whitespace-pre-wrap">
          {renderTextWithLinks(message.text)}
        </div>
      ) : null}

      {message.quickReplies?.length > 0 && (
        <QuickRepliesGrid
          quickReplies={message.quickReplies}
          onQuickReply={onQuickReply}
          isLoading={isLoading}
        />
      )}

      <span className="text-gray-400 px-1  text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
    </div>
  </div>
);

const MessageBubble = ({ message, onQuickReply, isLoading }) => {
  if (message.role === "user") {
    return <UserBubble message={message} />;
  }
  return <AssistantBubble message={message} onQuickReply={onQuickReply} isLoading={isLoading} />;
};

export default MessageBubble;
